import React from 'react';
import { useLocation } from "react-router-dom";
import { fetchBlogPostContent } from '../../api/MarketingApi';
import { formatDateTime } from '../../common/utils/utils';
import { useDocumentMetaData } from '../../common/components/useDocumentMetaData';

const BlogPostContent = () => {

    const location = useLocation();
    const blogPost = location.state?.blogPost; // Access the id from the location state

    const [blogList, setBlogList] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);

    useDocumentMetaData({
        title: blogPost?.title || "MyBuilderID",
        description: blogPost?.excerpt,
        keywords: "builder blog, construction tips, portfolio insights, builder success stories",
        canonical: `https://mybuilderid.com/${blogPost?.slug}`,
        robots: "index, follow",
        author: "MyBuilderID Team",
        ogTitle: blogPost?.title,
        ogDescription: blogPost?.excerpt,
        ogImage: blogPost?.imageUrl,
        ogUrl: `https://mybuilderid.com/${blogPost?.slug}`,
        twitterCard: "summary_large_image",
        twitterTitle: blogPost?.title,
        twitterDescription: blogPost?.excerpt,
        twitterImage: blogPost?.imageUrl
    });

    let FetchPosts = async () => {
        let resp = await fetchBlogPostContent({
            SearchList: [{
                slug: window.location.pathname.slice(1),
            }]
        });

        setBlogList(resp)
        setIsLoading(false)
    }

    React.useEffect(() => {
        try {
            FetchPosts()
        }
        catch (error) {
            console.log(error);
        }
    }, [])

    // Use blogId to fetch additional details or for any other purpose
    return (
        !isLoading && blogList?.length > 0 && <section className="container padding-top padding-bottom" >
            {/* Render blog post */}

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h2 style={{ textAlign: 'center' }}>{blogList[0].title}</h2>

                <img style={{
                    display: "block", // Ensures the image behaves as a block-level element
                    width: '100%', // Make the image full width on smaller screens
                    maxWidth: '600px', // Set a maximum width for larger screens
                    height: 'auto', // Maintain aspect ratio
                    margin: '40px auto 0px auto',
                    borderRadius: '4px',
                    objectFit: "cover"
                }}
                    src={blogList[0].imageUrl}
                    alt={blogList[0].title}
                />
                <div style={{ textAlign: 'center', color: 'gray', marginTop: '8px' }}>Published on {formatDateTime(blogList[0].datePosted)}</div>
            </div>

            <div className='padding-top' style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '100%' }}>
                    {blogList?.map((blog, index) =>
                        <div key={index} className="Container" dangerouslySetInnerHTML={{ __html: blog.content }}></div>
                    )}
                </div>
            </div>
        </section >
    )
}

export default BlogPostContent;
